<template>
    <v-layout column fill-height>
        <breadcrumbs guia="Painel de negócios" titulo="Painel de Negócios" descricao="Acompanhe a visão geral dos seus negócios com a Previsul." />

        <v-layout class="main full">
            <v-flex>
                <v-layout row class="content-body overflow-y-auto">
                    <v-flex md12>
                        <div class="flex-row">
                            <div class="flex-col-2">
                                <div class="dados-painel">
                                    <span class="titulo">Comissões Pagas <br>Mês Atual</span><br>
                                    <span class="subtitulo">(até {{ dataAtual }})</span><br>
                                    <!-- <span class="cifrao">R$</span>&nbsp;<span class="valor">{{ comissaoMesCorrente[0] }}</span><span class="centavos">,{{ comissaoMesCorrente[1] }}</span> -->
                                    <span class="cifrao">R$</span>&nbsp;<span class="valor">{{ comissaoMesCorrenteCompleto }}</span>
                                </div>
                            </div>
                            <div class="flex-col-2">
                                <div class="dados-painel">
                                    <span class="titulo">Comissões Pendentes</span><br>
                                    <span class="subtitulo">(em {{ dataAtual }})</span><br><br>
                                    <!-- <span class="cifrao">R$</span>&nbsp;<span class="valor">{{ comissaoPendente[0] }}</span><span class="centavos">,{{ comissaoPendente[1] }}</span> -->
                                    <span class="cifrao">R$</span>&nbsp;<span class="valor">{{ comissaoPendenteCompleto }}</span>
                                </div>
                            </div>
                            <div class="flex-col-2">
                                <div class="dados-painel">
                                    <span class="titulo">Cotações</span><br>
                                    <span class="subtitulo">(média últimos 12 meses)</span><br><br>
                                    <span class="valor">{{quantidadeCotacoes}}</span>
                                </div>
                            </div>

                            <div class="flex-col-1"></div>
                            <div class="flex-col-5">
                              <!--img src="/upload/promo-cota-mais.jpg" class="responsive hover" alt=""  v-on:click="redirectBanner()"-->
                              <img src="/upload/promo-portal-corretor.gif" class="responsive hover" alt="" >
                            </div>
                        </div>
                    </v-flex>
                    <v-flex md12>
                        <div class="flex-row">
                            <div class="flex-col-12 p-10">
                                <br><br>
                                <div class="box-shadow p-10">
                                    <line-chart :chart-data="dataChart" :options="options"></line-chart>
                                </div>
                                <br><br>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>

            </v-flex>

        </v-layout>
        

      <v-overlay :value="fullLoading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-dialog v-model="modalNotificacao" width="740" :hide-overlay="true">
        <v-card>
          <v-card-text>
            <p>
              <strong>Olá, Corretor!</strong> <br>
              A Previsul está sempre inovando para oferecer soluções digitais que facilitem ainda + o seu dia-a-dia.
              Por isso, temos uma novidade: a partir de agora, você e seus colaboradores podem receber diversas informações automaticamente via What’sApp, como atualizações no processo de movimentação de vida, status de pagamento de comissionamento e agenciamento, entre outros! <br><br>

              Essa nova funcionalidade pode ser acionada através dos perfis de seus colaboradores cadastrados no Portal. <br>
            </p>

            <p>
              <strong>QUERO EXPERIMENTAR:</strong> 
              <v-btn color="info" text  @click="confirmarNotificacao('sim')">SIM</v-btn>
              <v-btn color="red darken-1" text  @click="confirmarNotificacao('nao')">NÃO</v-btn>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-layout>
</template>


<script>

import LineChart from '@/components/chart/LineChart';
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";
import Vue from "vue";
import { mapGetters } from 'vuex';


export default {
  components: {
    breadcrumbs,
    LineChart
  },
  data(){
      return {
        dialog: true,
        fullLoading: false,
        labels: [],
        meses: ["", "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        comissoesAgenciamento: [],
        comissoesCorretagem: [],
        comissoesMedia: [],
        comissoesPagas: [],
        comissaoMesCorrente: [0,0],
        comissaoMesCorrenteCompleto: "",
        comissaoPendente: [0,0],
        comissaoPendenteCompleto: "",
        quantidadeCotacoes: 0,
        dataChart: {},
        options: {
            responsive: true, 
            maintainAspectRatio: false,                    
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                    display: true,
                    labelString: 'Mês/Ano'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                    display: true,
                    labelString: 'Comissão (R$)'
                    },
                    ticks: {
                        beginAtZero: true,
                        callback: value => this.FormatarValorMonetario(value)
                    }
                }]
            }        
        },
        dataAtual: "",
        modalNotificacao: false
      }
  },
    methods: {
      fillData () {
        this.dataChart = {
          labels: this.labels,
          datasets: [
            {
              label: 'Total de comissões pagas',
              backgroundColor: 'rgba(255, 255, 255, 0)',
              borderColor: 'rgba(100, 167, 11)',
              data: this.comissoesPagas
            },
            {
              label: 'Ageciamento',
              backgroundColor: 'rgba(255, 255, 255, 0)',
              borderColor: 'rgba(83, 168, 226)',
              data: this.comissoesAgenciamento
            }, 
            {
              label: 'Corretagem',
              backgroundColor: 'rgba(255, 255, 255, 0)',
              borderColor: 'rgba(179, 83, 226)',
              data: this.comissoesCorretagem
            }, 
            {
              label: 'Média dos últimos 12 meses',
              backgroundColor: 'rgba(255, 255, 255, 0)',
              borderColor: 'rgba(255, 208, 0)',
              data: this.comissoesMedia
            }
          ]
        }
      },
        FormatarValorMonetario(valor)
        {
            return valor.toLocaleString('pt-br', {minimumFractionDigits: 2});
        },         
        carregarGrafico()
        {
            this.fullLoading = true;        
            setTimeout(() => {
                let codCorretor = localStorage.getItem("codCor");

                
                //this.fullLoading = true;
                //let url = "Dashboard/comissoes/5294";
                let url = "Dashboard/comissoes/" + codCorretor;
                Vue.prototype.$httpPortal.get(url)
                    .then(res => {
                    // Carregando totalizadores
                    this.dataAtual = res.data.dataAtual;

                    this.comissaoMesCorrente = res.data.comissaoPagaMesCorrente > 0 ? (''+res.data.comissaoPagaMesCorrente+'').split('.') : [0,0] ;
                    this.comissaoMesCorrenteCompleto = this.FormatarValorMonetario(res.data.comissaoPagaMesCorrente);
                    
                    this.comissaoPendente = res.data.comissaoPendente != 0 ? (''+res.data.comissaoPendente+'').split('.') : [0,0];
                    this.comissaoPendenteCompleto = this.FormatarValorMonetario(res.data.comissaoPendente);
                    this.quantidadeCotacoes = res.data.quantidadeCotacaos;

                    let comissoes = res.data.comissaoRelatorio;
                    // Carregando agenciamento 
                    for(let item in comissoes.Agenciamento){
                        //this.comissoesAgenciamento.push(comissoes.Agenciamento[item].TotalComissao);
                        this.comissoesAgenciamento.push(this.FormatarValorMonetario(comissoes.Agenciamento[item].TotalComissao.toString()));
                        
                    }
                    // Carregando corretagem 
                    for(let item in comissoes.Corretagem){
                        //this.comissoesCorretagem.push(comissoes.Corretagem[item].TotalComissao);
                        this.comissoesCorretagem.push(this.FormatarValorMonetario(comissoes.Corretagem[item].TotalComissao.toString()));
                    }
                    // Carregando media 
                    for(let item in comissoes.Medias){
                        //this.comissoesMedia.push(comissoes.Medias[item].TotalComissao);
                        this.comissoesMedia.push(this.FormatarValorMonetario(comissoes.Medias[item].TotalComissao.toString()));
                    }
                    // Carregando pagas e labels
                    for(let item in comissoes.Pagas){
                        this.labels.push(this.meses[comissoes.Pagas[item].Mes] + "/" + comissoes.Pagas[item].Ano);
                        //this.comissoesPagas.push(comissoes.Pagas[item].TotalComissao);
                        this.comissoesPagas.push(this.FormatarValorMonetario(comissoes.Pagas[item].TotalComissao.toString()));
                    }

                    console.log("COMISSOES PAGAS");
                    console.log(this.comissoesPagas);

                    // Carrega informações no grafico
                    this.fillData();
                    this.fullLoading = false;

                    console.log(res.data);
                    })
                    .catch(ex => {
                        console.log(ex);
                        this.fullLoading = false;
                    });       
            }, 4000);                
        },    
      getCorretor(){
        //console.log(this.usuario);
      },
      redirectBanner(){
        let userRoleId = localStorage.getItem('userRoleId');

        if (userRoleId === null || userRoleId === undefined) {
          userRoleId = 0;
        }
        let urlCotaMais = `${this.$httpCotaMais.defaults.baseURL}?userRoleId=${userRoleId}&hash=${this.usuario.hash}&token=${this.usuario.token}`;
        window.open(urlCotaMais, '_blank');
      },
      buscarConfiguracao(){
          let _codCorretor = this.usuario.codCorretor;
          if(_codCorretor.length < 5)
          {
            let url = "Login/configuracao/" + this.usuario.codCorretor;
            Vue.prototype.$httpPortal.get(url)
            .then(res => {
                let configuracao = res.data;
            })
            .catch(error => {
                this.showToast("error","Erro!","Há problemas detectados");
            });
          }
      },
    },
    computed:{
      ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
    },
    mounted () {
        //this.getUserInfo();
        this.carregarGrafico();     
        console.log(this.usuario);
    },
 }
</script>

<style lang="scss">
    .dados-painel{
        .titulo{
            font-weight: bold;
            color: #3b454e;
        }
        .cifrao{
            color: #CFCFCF;
            font-size: 20px;
        }
        .valor{
            color: #5cd7fd;
            font-size: 20px;
        }
        .centavos{
            color: #5cd7fd;
            font-size: 20px;
        }
    }
</style>